// extracted by mini-css-extract-plugin
export default {"imageWrapper":"kI-z","twoColumnImage":"lI-z"};